import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { SettingsAction, SettingsPanel, SettingsSection, SettingsToggle } from "../Settings";

const PrivacySettings = ({ settings, onChange, onDeleteAccount }) => {
    const { t } = useTranslation();
    const resolvedSettings = {
        showActivityStatus: Boolean(settings?.showActivityStatus),
        allowDataCollection: Boolean(settings?.allowDataCollection),
    };

    const handleToggle = (key) => (value) => {
        onChange({ [key]: value });
    };

    return (
        <SettingsPanel
            title={t("profile.privacy.panelTitle")}
            description={t("profile.privacy.panelDescription")}
        >
            <SettingsSection
                title={t("profile.privacy.sections.visibilityTitle")}
                description={t("profile.privacy.sections.visibilityDescription")}
            >
                <SettingsToggle
                    name="privacy-activity"
                    label={t("profile.privacy.toggles.activityLabel")}
                    description={t("profile.privacy.toggles.activityDescription")}
                    checked={resolvedSettings.showActivityStatus}
                    onChange={handleToggle("showActivityStatus")}
                />
            </SettingsSection>
            <SettingsSection
                title={t("profile.privacy.sections.dataTitle")}
                description={t("profile.privacy.sections.dataDescription")}
            >
                <SettingsToggle
                    name="privacy-analytics"
                    label={t("profile.privacy.toggles.analyticsLabel")}
                    description={t("profile.privacy.toggles.analyticsDescription")}
                    checked={resolvedSettings.allowDataCollection}
                    onChange={handleToggle("allowDataCollection")}
                />
            </SettingsSection>
            <SettingsSection
                title={t("profile.accountDeletion.dangerZoneTitle")}
                description={t("profile.accountDeletion.dangerZoneDescription")}
            >
                <SettingsAction
                    label={t("profile.accountDeletion.actionLabel")}
                    description={t("profile.accountDeletion.actionDescription")}
                    buttonLabel={t("profile.accountDeletion.actions.open")}
                    buttonVariant="danger"
                    onClick={onDeleteAccount}
                />
            </SettingsSection>
        </SettingsPanel>
    );
};

PrivacySettings.propTypes = {
    settings: PropTypes.shape({
        showActivityStatus: PropTypes.bool,
        allowDataCollection: PropTypes.bool,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onDeleteAccount: PropTypes.func,
};

PrivacySettings.defaultProps = {
    onDeleteAccount: () => {},
};

export default PrivacySettings;
